import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface IDateTimeSelectorProps {
    id: string;
    cssClass: string;
    date: Date;
    onSelectOp: number;
    dateFormat: string;
    parseFormats?: string[];
    disabled: boolean;
    dataCy?: string;

    /**
     * A callback invoked when the selected date changes, in cases where you don't need to use
     * {@link onSelectOp}.
     */
    onChangeCallback?: (value: Date) => void;

    toDayEnabled?: boolean;
    todayOperation?: number
}

class DateTimeSelector extends React.Component<IDateTimeSelectorProps, never> {
    private culture: string;

    constructor(props: IDateTimeSelectorProps) {
        super(props);
        this.culture = sessionStore.getUserLanguageCodeFull();
    }

    public render(): JSX.Element {
        var TodayRender: JSX.Element;
        if (this.props.toDayEnabled) {
            TodayRender = <span> <a onClick={this.onTodayClick.bind(this)}> {cacheStore.GetString("TodayLabel")} </a></span>;
        }
        return (
            <div>
                <input type="text" disabled={this.props.disabled} id={this.props.id} className={this.props.cssClass} data-cy={this.props.dataCy} />
                {TodayRender}
            </div>
        );
    }

    public componentDidMount(): void {
        var self = this;
        $("#" + this.props.id).kendoDateTimePicker({
            culture: self.culture,
            format: self.props.dateFormat,

            value: self.props.date,
            parseFormats: self.props.parseFormats,
            footer: null,
            change: e => {
                const value = e.sender.value();
                if (self.props.onSelectOp)
                    sessionStore.dispatch(self.props.onSelectOp, { value });
                self.props.onChangeCallback?.(value);
            }
        });
    }

    public onTodayClick(e: React.MouseEvent): void {
        e.preventDefault();
        var operation = new LocalEvent(this.props.todayOperation);
        LocalEventDispatcher.dispatch(operation);
    }

    public shouldComponentUpdate(nextProps: IDateTimeSelectorProps): boolean {
        return (
            nextProps.disabled !== this.props.disabled
            || nextProps.date !== this.props.date
        );
    }

    public componentDidUpdate(): void {
        $("#" + this.props.id).data("kendoDateTimePicker").value(kendo.toString(this.props.date, this.props.dateFormat, this.culture));
    }

    public componentWillUnmount(): void {
        try {
            $("#" + this.props.id).data("kendoDateTimePicker").destroy();
        }
        catch (e) { }
    }
}

export { DateTimeSelector };
